import { adminCall } from '../../api/adminCall';

export async function applyCompanyPackage({ companyId, packageId, billingCycle }) {
  return adminCall(
    `/api/admin/companies/${encodeURIComponent(companyId)}/package/apply`,
    { packageId, billingCycle }
  );
}

export async function removeCompanyPackage({ companyId }) {
  return adminCall(`/api/admin/companies/${encodeURIComponent(companyId)}/package/remove`);
}

export async function expireCompanyPackage({ companyId }) {
  return adminCall(`/api/admin/companies/${encodeURIComponent(companyId)}/package/expire`);
}

export async function adjustCompanySubscription(payload) {
  const { companyId, ...rest } = payload || {};
  if (!companyId) throw new Error('companyId is required');
  return adminCall(
    `/api/admin/companies/${encodeURIComponent(companyId)}/subscription/adjust`,
    rest
  );
}
